import { theme } from '@features/executive-report/domain/theme';
import {
  Slide,
  TextProps,
  TextPropsTextConfig,
  ZERO_WIDTH_SPACE,
  parseContent,
} from '@features/powerpoint';
import { contentSlideTitleText } from '../../../../slides/content-slide-title-text';
import { DriverTextsOptions, driverTexts } from './driver-texts';
import { keyResultsTexts } from './key-results-texts';
import { headerTabs } from '../header-tabs';
import { CampaignOverviewSlide2Options } from '../campaign-overview-2';

export const DEFAULT_FONT_SIZE = 14;

const columnText = (
  text: string,
  options?: TextProps['options']
): TextProps => ({
  text: text.toUpperCase(),
  options: {
    fontSize: DEFAULT_FONT_SIZE,
    color: theme.colors.white,
    bold: true,
    h: 0.34,
    w: 1.37,
    x: 1.66,
    y: 1.65,
    ...options,
  },
});

const objectiveListText = (text: string): TextPropsTextConfig[] => [
  {
    text: ZERO_WIDTH_SPACE,
    options: {
      bullet: { indent: 20 },
      color: theme.colors.inmarketGreen,
      fontSize: 20,
      bold: true,
    },
  },
  {
    text,
  },
];

export const texts = (
  options: CampaignOverviewSlide2Options & {
    driverTextsOptions: DriverTextsOptions[];
  }
): Slide['texts'] => {
  const totalIncrementalLift = options.report.incrementalSalesLift;
  const totalIncrementalSales = options.report.projectedIncrementalSales;

  return [
    ...headerTabs('overview'),
    contentSlideTitleText('<b>Campaign</b> <lci>Overview</lci>'),
    columnText('Objective'),
    {
      text: options.objectives.flatMap((text: string) =>
        objectiveListText(text)
      ),
      options: {
        fontSize: DEFAULT_FONT_SIZE,
        color: theme.colors.white,
        valign: 'top',
        paraSpaceAfter: DEFAULT_FONT_SIZE,
        h: 3.39,
        w: 3.2,
        x: 0.74,
        y: 3.64,
      },
    },
    columnText('Key Results', { x: 5.43, w: 1.59 }),
    ...keyResultsTexts({
      totalIncrementalLift,
      totalIncrementalSales,
      iroas: options.iroas,
    }),
    columnText('Key Drivers', { x: 9.95, w: 1.59 }),
    {
      text: parseContent('More is <lci>more.</lci>'),
      options: {
        fontSize: 40,
        color: theme.colors.white,
        h: 0.77,
        w: 4.38,
        x: 8.57,
        y: 2.31,
      },
    },
    ...options.driverTextsOptions.flatMap((driverOptions: DriverTextsOptions) =>
      driverTexts(driverOptions)
    ),
  ];
};
